module.exports = __webpack_public_path__ + "img/title1.e44d30ab.png";